import React, { useMemo, useState } from 'react';
import propTypes from 'prop-types';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import IconButton from '@material-ui/core/IconButton';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemAvatar from '@material-ui/core/ListItemAvatar';
import ListItemText from '@material-ui/core/ListItemText';
import Tooltip from '@material-ui/core/Tooltip';
import moment from 'moment';
import { MdComment, MdCommentsDisabled } from 'react-icons/md';

import Typography from '../Typography';
import Modal from '../Modal';

import styles from './styles';

const ComentarioItem = ({ comentario }) => {
  const {
    contenido,
    fechaModificacion,
    fechaRegistro,
    usuarioModificacion,
    usuarioRegistro,
  } = comentario;

  const fecha = useMemo(() => {
    return fechaModificacion ? `Última actualización ${moment(fechaModificacion).format('lll')}` : moment(fechaRegistro).format('lll');
  }, [fechaModificacion, fechaRegistro]);

  const usuario = useMemo(() => {
    return usuarioModificacion || usuarioRegistro;
  }, [usuarioModificacion, usuarioRegistro]);

  const secondary = useMemo(() => `${usuario} - ${fecha}`, [fecha, usuario])

  return (
    <ListItem alignItems="flex-start">
      <ListItemAvatar>
        <Avatar></Avatar>
      </ListItemAvatar>
      <ListItemText primary={contenido} secondary={secondary} />
    </ListItem>
  );
};

const Comentarios = ({ comentarios }) => {
  const classes = styles();
  const [abrirComentarios, setAbrirComentarios] = useState(false);

  const abrirModal = () => {
    setAbrirComentarios(true);
  };

  const cerrarModal = () => {
    setAbrirComentarios(false);
  };

  return (
    <div>
      <Modal maxWidth="xs" open={abrirComentarios} titulo="Comentarios" handleClose={cerrarModal}>
        <List classes={{ root: classes.list }}>
          {comentarios.map((comentario, index) => (
             <React.Fragment key={comentario.id}>
              <ComentarioItem comentario={comentario} />
              {index < comentarios.length - 1 && <Divider variant="inset" component="li" />}
            </React.Fragment>
          ))}
        </List>
      </Modal>
      <Tooltip
        arrow
        classes={{ tooltip: classes.tooltip }}
        title={
          <Typography className={classes.tooltipText} variant="body1" component="p">
            {comentarios.map(({ contenido }) => contenido).join(', ')}
          </Typography>
        }
      >
        <IconButton onClick={abrirModal} disabled={!comentarios.length}>
          {comentarios.length ? <MdComment /> : <MdCommentsDisabled />}
        </IconButton>
      </Tooltip>
    </div>
  );
};

Comentarios.propTypes = {
  comentarios: propTypes.arrayOf(
    propTypes.shape({
      id: propTypes.string,
      contenido: propTypes.string,
      usuarioRegistro: propTypes.string,
      usuarioModificacion: propTypes.string,
      fechaRegistro: propTypes.string,
      fechaModificacion: propTypes.string,
    }),
  ),
};

export default React.memo(Comentarios);
